import React from "react";
interface props {
  className?: string;
  fill?: string;
  pathFill?: string;
}
function CallIcon2({ className, fill, pathFill }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      className={className}
      fill="none"
      viewBox="0 0 42 42"
    >
      <rect width="42" height="42" fill={fill || "#FEECE6"} rx="21"></rect>
      <path
        fill={pathFill || "#FF752C"}
        d="M18.384 11.479l-.86.259a4.2 4.2 0 00-2.945 3.425c-.357 2.481.44 5.383 2.361 8.71 1.917 3.32 4.026 5.458 6.348 6.394a4.2 4.2 0 004.458-.846l.65-.617a2.4 2.4 0 00.297-3.147L27.066 23.4a1.8 1.8 0 00-1.986-.668l-2.461.753-.064.012c-.271.04-.897-.547-1.677-1.899-.816-1.413-.984-2.24-.76-2.454l1.252-1.167a3 3 0 00.69-3.42l-.795-1.765a2.4 2.4 0 00-2.881-1.314zm1.79 1.806l.791 1.765a1.8 1.8 0 01-.413 2.052l-1.255 1.169c-.804.76-.537 2.059.543 3.928 1.015 1.76 1.941 2.628 2.937 2.477l.149-.031 2.506-.764a.6.6 0 01.662.222l1.627 2.256a1.2 1.2 0 01-.147 1.574l-.652.617a3 3 0 01-3.184.603c-2.037-.82-3.963-2.773-5.757-5.88-1.799-3.114-2.527-5.762-2.214-7.94a3 3 0 012.103-2.447l.86-.259a1.2 1.2 0 011.44.658"
      ></path>
    </svg>
  );
}

export default CallIcon2;
